import { useEffect, useRef } from 'react';

/**
 * Custom hook for polling mechanism
 * @param {Function} callback - Function to execute on each poll
 * @param {number} interval - Polling interval in milliseconds
 * @param {boolean} isPolling - Whether polling is active
 * @param {Object} options - Additional options
 * @param {boolean} options.runOnMount - Whether to run the callback immediately on mount/start
 */
export const usePolling = (callback, interval = 5000, isPolling = true, options = {}) => {
    const { runOnMount = true } = options;
    const savedCallback = useRef(callback);

    // Update the ref whenever the callback changes
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!isPolling || interval === null) return;

        const tick = () => {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };

        if (runOnMount) {
            tick();
        }

        const id = setInterval(tick, interval);
        return () => clearInterval(id);
    }, [interval, isPolling, runOnMount, callback]);
};
